import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';

import { PropertyListingStateService } from '../../../../../app/shared/services/sell-your-property/property-listing-state.service';
import { NotificationService } from '../../../../../app/shared/services/notification-service/notification.service';

@Component({
  selector: 'app-listing-order-details',
  templateUrl: './listing-order-details.component.html',
  styleUrls: ['./listing-order-details.component.scss', '../../../../../css/2-modules/_forms.scss']
})
export class ListingOrderDetailsComponent implements OnInit {

  @Output() pageNumberEvent = new EventEmitter<number>();
  @Output() formSubmittedEvent = new EventEmitter<void>();

  orderDetailsForm: FormGroup;

  selectedFeeOption: 'direct' | 'success' | null = null;
  selectedReportLevel: 1 | 2 | null = null;

  constructor(
    private _formBuilder: FormBuilder,
    private _notificationService: NotificationService,
    private _propertyListingStateService: PropertyListingStateService
  ) { }

  ngOnInit(): void {
    this.orderDetailsForm = this._formBuilder.group({
      reportLevel:                     [null, Validators.required],
      eligibilityLevel1Price:          [false],
      eligibilityDevelopmentPotential: [false],
      feeOption:                       [null, Validators.required]
    });

    this._propertyListingStateService.formState$.subscribe((formState) => {
      const orderDetail = (formState as any)?.orderDetail;
      if (orderDetail) {
        this.selectedFeeOption   = orderDetail.feeOption   ?? null;
        this.selectedReportLevel = orderDetail.reportLevel ?? null;
        this.orderDetailsForm.patchValue({
          reportLevel:                     orderDetail.reportLevel                     ?? null,
          eligibilityLevel1Price:          orderDetail.eligibilityLevel1Price          ?? false,
          eligibilityDevelopmentPotential: orderDetail.eligibilityDevelopmentPotential ?? false,
          feeOption:                       orderDetail.feeOption                       ?? null
        });
      }
    });
  }


  get showLevel1PriceError(): boolean {
    return false;
  }

  onReportLevelChange(event: MatRadioChange): void {
    this.selectedReportLevel = event.value;
  }

  onFeeOptionChange(event: MatRadioChange): void {
    this.selectedFeeOption = event.value;
  }

  get isLevel1(): boolean {
    return this.orderDetailsForm.get('reportLevel')?.value === 1;
  }

  onSubmit(): void {
    if (!this.orderDetailsForm.value.reportLevel) {
      this._notificationService.showErrorMessage('Error', 'Please select a report level to continue.');
      return;
    }

    if (!this.orderDetailsForm.value.feeOption) {
      this._notificationService.showErrorMessage('Error', 'Please select a professional fee option to continue.');
      return;
    }

    if (this.orderDetailsForm.valid) {
      this._propertyListingStateService.updateOrderDetail({
        reportLevel:                     this.orderDetailsForm.value.reportLevel,
        eligibilityLevel1Price:          this.orderDetailsForm.value.eligibilityLevel1Price,
        eligibilityDevelopmentPotential: this.orderDetailsForm.value.eligibilityDevelopmentPotential,
        feeOption:                       this.orderDetailsForm.value.feeOption
      });
      this.formSubmittedEvent.emit();
      this.pageNumberEvent.emit(2);
    } else {
      this._notificationService.showErrorMessage('Error', 'Could not submit order details form. Please check the form and try again.');
    }
  }
}
